import { getClickId } from '$lib/PageSections/Forms/formUtils';

export function getRedditClickId(url) {
	return getClickId(url, 'rdt_cid');
}
